<img
  alt="informativo"
  class="dark-tooltip"
  [ngClass]="{ 'max-content': !breakLine }"
  src="/assets/images/icons/info-circle-yellow.svg"
  [outsideClick]="true"
  [popover]="content"
/>
